import { LoaderIcon } from "@/assets/icons";

interface LoadingStateProps {
  message?: string;
  testId?: string;
}

/**
 * Loading state component with spinner
 */
export default function LoadingState({
  message = "Loading...",
  testId = "loading-state"
}: LoadingStateProps) {
  return (
    <div
      className="flex flex-col items-center justify-center h-full text-center text-sm text-dim-gray gap-2 my-auto"
      data-testid={testId}
    >
      <LoaderIcon className="animate-spin" width={60} height={60} />
      <p className="text-txtPlaceholder">{message}</p>
    </div>
  );
}
